/* eslint no-undef: "off"*/

import PubSub from "pubsub-js";
import { eventNames } from "../constants/eventNames";

type StoredValue = {
  componentMode?: string;
  validationMode?: boolean;
  isRecording?: boolean;
  [key: string]: any;
};

type ValidationData = {
  validation: boolean;
};

export const getComponentMode = (): string => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);
  if (!storedValue || storedValue.componentMode === undefined || !storedValue.componentMode) {
    return "user";
  }

  return storedValue.componentMode;
};

export const setComponentMode = (mode: string): void => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);

  if (mode !== "dev") {
    let data: ValidationData = {
      validation: false
    };
    PubSub.publish(eventNames.validationModeUiUpdate, data);
    if (storedValue !== null) {
      storedValue.validationMode = false;
      storedValue.componentMode = mode;
      // ⚠️ FIX: Do NOT force isRecording to false here.
      // Recording should only be turned off by explicit user action (popup toggle).
      // ComponentMode can change independently of recording state
      // (e.g., when navigating between components on UIFlow tab).
      // Leave isRecording as-is — it's managed by the extension popup.
      localStorage.setItem("default_ext_values", JSON.stringify(storedValue));
    } else {
      // Read existing isRecording from chrome storage sync if available
      // Otherwise default to false (no prior recording state)
      let localStoredValue: StoredValue = {
        validationMode: false,
        componentMode: mode,
        isRecording: false  // Safe default for first-time creation (no prior state)
      };
      localStorage.setItem("default_ext_values", JSON.stringify(localStoredValue));
    }
  } else {
    // mode === "dev" - update componentMode ONLY.
    // ⚠️ STRICT FIX: componentMode change must NEVER touch isRecording.
    // Recording state is authoritative from the popup toggle only. Previously this
    // forced isRecording=true whenever setComponentMode('dev') ran (e.g. via Capture
    // Page, opening a component), which clobbered the user's explicit OFF toggle.
    if (storedValue !== null) {
      storedValue.componentMode = mode;
      localStorage.setItem("default_ext_values", JSON.stringify(storedValue));
    } else {
      let localStoredValue: StoredValue = {
        componentMode: mode,
        isRecording: false,
        validationMode: false
      };
      localStorage.setItem("default_ext_values", JSON.stringify(localStoredValue));
    }
  }
};

export const getValidationMode = (): boolean => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);
  if (!storedValue || storedValue.validationMode === undefined || !storedValue.validationMode) {
    return false;
  }
  return storedValue.validationMode;
};

export const setValidationMode = (mode: boolean): void => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);
  if (storedValue !== null && storedValue.validationMode !== undefined) {
    storedValue.validationMode = mode;
    localStorage.setItem("default_ext_values", JSON.stringify(storedValue));
  }
};

export const isRecording = (): boolean => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);
  if (!storedValue || storedValue.isRecording === undefined) {
    return false;
  }
  return storedValue.isRecording === true;
};

export const setRecording = (recording: boolean): void => {
  let storedValue: StoredValue | null =
    localStorage.getItem("default_ext_values") && JSON.parse(localStorage.getItem("default_ext_values")!);

  if (storedValue !== null) {
    storedValue.isRecording = recording;
    localStorage.setItem("default_ext_values", JSON.stringify(storedValue));
  } else {
    // Create new localStorage entry if it doesn't exist
    let localStoredValue: StoredValue = {
      isRecording: recording,
      componentMode: "user",
      validationMode: false
    };
    localStorage.setItem("default_ext_values", JSON.stringify(localStoredValue));
  }
};
